var map = {
	"./ico-monitor.png": 508,
	"./ico-streaming.png": 509,
	"./noimg.jpg": 510
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 882;


//////////////////
// WEBPACK FOOTER
// ./src/app/website/pregao-comitente/assets/images ^\.\/.*$
// module id = 882
// module chunks = 2